import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { VUE_DIALOG_CONFIG } from 'vue/utilities/vue-dialog-config';

/**
 *  Component for removing an individual pool occurrence
 */
@Component({
    selector: 'app-remove-occurrence',
    templateUrl: './remove-occurrence.component.html',
    standalone: false
})
export class RemoveOccurrenceComponent {
  public constructor(
  // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    @Inject(MAT_DIALOG_DATA) public data: RemoveOccurrenceInputs,
    private dialogRef: MatDialogRef<RemoveOccurrenceComponent>
  ) {}

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public removeOccurrence(): void {
    this.data.removeOccurrenceCallback();
    this.closeDialog();
  }
}

export const removeOccurrenceConfig = {
  ...VUE_DIALOG_CONFIG,
};

export interface RemoveOccurrenceInputs {

  /**
   * Title shown on top of dialog
   */
  title: Observable<string>;

  /**
   * Callback used when remove is chosen by the user
   */
  removeOccurrenceCallback: () => void;
}
